import React from 'react';

const WhyUs = () => {
    return (
        <div>
          <section id="pageTitle" className="page-title page-title-layout1 bg-overlay bg-parallax">
            <div className="bg-img"><img src="assets/images/page-titles/why.jpg" alt="background" /></div>
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <h1 className="pagetitle__heading">Why Evermore?</h1>
                  <p className="pagetitle__desc">We recognize the overall business objectives of our clients and the role effective Facilities Management plays in enabling our customers to meet their objectives</p>
                  <a href="/services.php" className="btn btn__primary btn__hover2">
                    <i className="icon-arrow-right" /><span>Our Services</span>
                  </a>
                </div>{/* /.col-xl-7 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>{/* /.page-title */}
          {/* ========================
        About Layout 2
      =========================== */}
          <section id="textContentSection" className="text-content-section pt-120 pb-90">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-4">
                  <aside className="sidebar mb-30">
                    <div className="widget widget-help bg-overlay bg-overlay-theme">
                      <div className="bg-img"><img src="assets/images/banners/2.jpg" alt="background" /></div>
                      <div className="widget__content">
                        <div className="widget__icon">
                          <i className="icon-worker-2" />
                        </div>
                        <h5>Dedicated Customer Teams &amp; Agile Services</h5>
                        <p>Our worldwide presence ensures the timeliness, cost efficiency compliance adherence required to
                          ensure your production timelines.</p>
                        <a href="whyEvermore#" className="btn btn__white btn__link">
                          <i className="icon-arrow-right" /> <span>Schedule An Appointment</span>
                        </a>
                      </div>{/* /.widget-download */}
                    </div>{/* /.widget-help */}
                    <div className="widget widget-download">
                      <h5 className="widget__title">Download</h5>
                      <div className="widget__content">
                        <a href="whyEvermore#" className="btn btn__secondary btn__block btn__hover3">
                          <span>Company Brochure</span>
                          <img src="assets/images/icons/pdf.png" alt="pdf" />
                        </a>
                      </div>{/* /.widget-content */}
                    </div>{/* /.widget-download */}
                  </aside>{/* /.sidebar */}
                </div>{/* /.col-lg-4 */}
                <div className="col-sm-12 col-md-12 col-lg-8">
                  <div className="text__block mb-40">
                    <div className="text__block">
                      <h5 className="text__block-title">Why Us!</h5>
                    </div>{/* /.text-block */}
                    <div className="features-list mb-30">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="feature-item feature-list-item">
                            <div className="feature__content">
                              <h4 className="feature__title">Bespoke Client Solutions.</h4>
                            </div>{/* /.feature-content */}
                          </div>{/* /.feature-item */}
                          <div className="feature-item feature-list-item">
                            <div className="feature__content">
                              <h4 className="feature__title">Awards and Recognition</h4>
                            </div>{/* /.feature-content */}
                          </div>{/* /.feature-item */}
                        </div>{/* /.col-lg-6 */}
                        <div className="col-sm-12 col-md-12 col-lg-6">
                          <div className="feature-item feature-list-item">
                            <div className="feature__content">
                              <h4 className="feature__title">Health, Safety and Environment</h4>
                            </div>{/* /.feature-content */}
                          </div>{/* /.feature-item */}
                          <div className="feature-item feature-list-item">
                            <div className="feature__content">
                              <h4 className="feature__title">Client portfolio</h4>
                            </div>{/* /.feature-content */}
                          </div>{/* /.feature-item */}
                        </div>{/* /.col-lg-6 */}
                      </div>{/* /.row */}
                    </div>{/* /.features-list */}
                    <p className="text__block-desc" style={{color: '#000'}}>
                    </p><div className="footer__widget footer__widget-nav">
                      <h6 className="footer__widget-title" style={{color: '#000'}}>Our facility management solutions are adaptable, evolve with the client needs and cover the following areas:</h6>
                      <div className="footer__widget-content">
                        <nav>
                          <ul className="list-unstyled">
                            <li><a href="whyEvermore#" style={{color: '#000', fontSize: '16px'}}>Strengthen clients brand positioning by reducing delivery risks.</a></li>
                            <li><a href="whyEvermore#" style={{color: '#000', fontSize: '16px'}}>Implementacustomerservicemodelthatisfocused on the delivery of “best in class” services.</a></li>
                            <li><a href="whyEvermore#" style={{color: '#000', fontSize: '16px'}}>Align our product portfolio and processes in accordance with contractual as well as customer expectations.</a></li>
                            <li><a href="whyEvermore#" style={{color: '#000', fontSize: '16px'}}>Provide risk free handover and delivery processes.</a></li>
                            <li><a href="whyEvermore#" style={{color: '#000', fontSize: '16px'}}>Continuously implement customer feedback to support our procedures and continuous improvement program.</a></li>
                          </ul>
                        </nav>
                      </div>{/* /.footer-widget-content */}
                    </div>{/* /.col-xl-2 */}
                    <p />
                  </div>{/* /.text-block */}
                  <div className="text__block">
                    <h5 className="text__block-title">Awards and Recognition</h5>
                    <p className="text__block-desc">We have more than twenty years of experience. During that time, we’ve
                      become expert in freight transportation by air and all its related services. We work closely with
                      all major airlines around the world. Ongoing negotiations ensure that we always have the cargo
                      space we need and offer you competitive rates.
                    </p>
                  </div>{/* /.text-block */}
                  <div className="row">
                    {/* Blog Item #1 */}
                    <div className="col-sm-12 col-md-6 col-lg-12">
                      <div className="blog-item">
                        <div className="blog__img">
                          <a href="whyEvermore#">
                            <img src="assets/images/award.jpg" alt="blog images" />
                          </a>
                        </div>
                      </div>{/* /.blog-item */}
                    </div>{/* /.col-lg-4 */}
                  </div>{/* /.video */}
                </div>{/* /.col-lg-8 */}
              </div>{/* /.row */}
            </div>{/* /.container */}
          </section>{/* /.Text Content Section */}
        </div>
      );
};

export default WhyUs;
